import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../hooks/useLanguage';
import { CartContext } from '../../context/CartContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import './CartIcon.css';

const CartIcon = () => {
  const { itemCount } = useContext(CartContext);
  const lang = useLanguage();

  // If there are no items in the cart, do not render the icon.
  if (itemCount === 0) {
    return null;
  }

  return (
    <Link to={`/${lang}/cart`} className="cart-icon-container">
      <FontAwesomeIcon icon={faShoppingCart} className="cart-icon" />
      <span className="cart-item-count">{itemCount}</span>
    </Link>
  );
};

export default CartIcon;
